import { ContactPageSharp } from "@mui/icons-material";
import dayjs from "dayjs";
import {
  collection,
  getDocs,
  getDoc,
  setDoc,
  doc,
  addDoc,
  updateDoc,
} from "firebase/firestore";
import { firestore } from "../firebase";

export const getUsers = async () => {
  const data = [];
  const querySnapshot = await getDocs(collection(firestore, "users"));
  querySnapshot.forEach((document) => {
    data.push({
      ...document.data(),
      firebaseId: document.id,
    });
  });
  return data;
};

export const setOrder = async (account, userDetails) => {
  return await setDoc(
    doc(collection(firestore, "users"), account),
    userDetails
  );
};

export const getUser = async (account) => {
  const querySnapshot = await getDoc(
    doc(collection(firestore, "users"), account)
  );
  return querySnapshot.exists()
    ? { ...querySnapshot.data(), firebaseId: querySnapshot.id }
    : {};
};

export const printTee = async (values, docData) => {
  try {
    let printTee;
    const d = await getDoc(docData);
    const data = d.data()?.printTee;
    if (data) {
      printTee = data;
    } else {
      printTee = [];
    }

    values.transactionDate = new Date().toLocaleString();
    if (values.paymentIntentId) {
      printTee.push({
        paymentIntentId: values.paymentIntentId,
        billingAddress: values.address,
        size: values.size,
        account: values.account,
        fullName: values.fullName,
        transactionDate: values.transactionDate,
      });
    } else {
      values.mintNftVerify = `${process.env.REACT_APP_DOMAIN}/verify-nft?tokenId=${values.mintDataToken}`;
      printTee.push({
        billingAddress: values.address,
        fullName: values.fullName,
        mintDataToken: values.mintDataToken,
        mintHashCode: values.mintHashCode,
        mintNftVerify: `${process.env.REACT_APP_DOMAIN}/verify-nft?tokenId=${values.mintDataToken}`,
        transactionDate: values.transactionDate,
      });
    }
    const resData = await updateDoc(docData, {
      printTee: printTee,
    });

    return await setDoc(doc(collection(firestore, "print-tee")), values);
  } catch (err) {
    // console.log(err);
  }
};

export const createUser = async (values) => {
  try {
    const user = await getDoc(
      doc(collection(firestore, "users"), values.account)
    );
    if (!user.exists()) {
      await setDoc(doc(collection(firestore, "users"), values.account), {
        type: "user",
        joinedDate: dayjs().format("DD-MM-YYYY"),
      });
    }
  } catch (e) {
    // console.log(e);
  }
};
